import { useTranslation } from 'react-i18next';
import { ChangeEvent } from 'react';

interface StepOptionsProps {
  keepDismissals: boolean;
  onChange: (value: boolean) => void;
}

const StepOptions = ({ keepDismissals, onChange }: StepOptionsProps) => {
  const { t } = useTranslation('roll-forward');

  return (
    <div className="roll-forward__step">
      <h4 className="roll-forward__heading">{t('step.options')}</h4>
      <label className="roll-forward__checkbox">
        <input
          type="checkbox"
          aria-label={t('keep-dismissals')}
          checked={keepDismissals}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
        />
        <span>{t('keep-dismissals')}</span>
      </label>
      <p className="roll-forward__hint text-gray-500">{t('keep-dismissals.hint')}</p>
    </div>
  );
};

export default StepOptions;
